<div class="betting-section">
  <div class="header-section">
    <app-profile></app-profile>

    <div class="control-container">
      <div class="control" (click)="openInfoModal()">
        <app-info-svg></app-info-svg>
      </div>
      <div class="control" *ngIf="canLeave" (click)="onClickLeaveRoom()">
        <app-arrow-right-svg></app-arrow-right-svg>
      </div>
    </div>
  </div>
  <div class="body-section">
    <div class="stats-container">
      <div>
        <span class="label">Your Chips: </span
        ><span class="value">{{ chips | number: '0.0-2' }}</span>
        <fa-icon
          class="default-icon ml-1 mt-1"
          (click)="onClickShowChipsRequestModal()"
          [icon]="faCoins"
        ></fa-icon>
      </div>
      <div>
        <span class="label">Your Seat No.: </span
        ><span class="value">{{ currentSeatNo || 'N/A' }}</span>
      </div>
    </div>
  </div>
  <div class="result-section mt-2 h-6">
    <div class="absolute w-full">
      <app-betted-chips
        [show]="showResult"
        [useEarnClass]="isWinner"
        [chips]="betAmount || chipsResult"
      ></app-betted-chips>
    </div>
    <div class="absolute w-full">
      <app-incomming-chips-label
        [show]="incommingChips?.show === true"
        [chips]="incommingChips?.chips || 0"
        [useEarnClass]="incommingChips?.useEarnClass === true"
        (onClose)="hideIncommingChipsLabel()"
      ></app-incomming-chips-label>
    </div>
  </div>
  <div class="pot-bonus">
    <div>{{ potBonusAmount | number: '1.0-2' }}</div>
    <h3>POT</h3>
  </div>

  <div *ngIf="mode === modeType.Paused; else playingSection">
    <div class="mt-10 items-center text-center">
      <p>Game is paused</p>
    </div>
  </div>

  <ng-template #playingSection>
    <div class="relative" *ngIf="showBuyIn; else bettingSection">
      <h3 class="insufficient-message" *ngIf="chips < allowedChipsToBuyin">Insuficient balance</h3>
    </div>

    <ng-template #bettingSection>
      <div class="input-container" *ngIf="isPlayerTurn; else waitingSection">
        <div class="easypick-container">
          <button
            class="!h-6 !w-fit !px-2 !py-0 !text-xs"
            *ngFor="let easyPick of easyPicks"
            [class.selected]="selectedEasyPick === easyPick.value"
            (click)="onClickEasyPick(easyPick.value)"
            [disabled]="isBetLock || disableEasyPick(easyPick.value)"
          >
            {{ easyPick.name }}
            <h3 class="ml-[1px] text-xs">{{ getEasyPickAmount(easyPick.value) }}</h3>
          </button>
          <!-- <app-button
            *ngFor="let easyPick of easyPicks"
            [isSelected]="selectedEasyPick === easyPick.value"
            [warning]="true"
            [rounded]="true"
            [disabled]="isBetLock || disableEasyPick(easyPick.value)"
            [sm]="true"
            (click)="onClickEasyPick(easyPick.value)"
          >
            {{ easyPick.name }}
            <h3 class="ml-1 text-xs">{{ getEasyPickAmount(easyPick.value) }}</h3>
          </app-button> -->
        </div>

        <div *ngIf="isPair; else elseBlock" class="mt-4">
          <div class="betting-buttons">
            <div class="button-holder-3">
              <!-- <app-button
                [success]="true"
                (click)="onClickSetBet(betType.HIGHER)"
                [rounded]="true"
                [isSelected]="selectedBet === betType.HIGHER"
                [disabled]="disableBetting"
                [md]="true"
              >
                High
              </app-button> -->

              <button
                class="md:btn-betting-md btn-betting"
                (click)="onClickSetBet(betType.HIGHER)"
                [class.selected-high]="selectedBet === betType.HIGHER"
                [disabled]="disableBetting"
              >
                High
              </button>
              <button
                class="md:btn-betting-md btn-betting"
                (click)="onClickSetBet(betType.LOWER)"
                [class.selected-lower]="selectedBet === betType.LOWER"
                [disabled]="disableBetting"
              >
                Low
              </button>
              <button
                class="md:btn-betting-md btn-betting"
                (click)="onClickFoldBet()"
                [class.selected-fold]="selectedBet === betType.FOLD"
                [disabled]="isBetLock"
              >
                Fold
              </button>
            </div>
          </div>
        </div>

        <ng-template #elseBlock>
          <div class="betting-buttons">
            <div class="button-holder-3 !grid-cols-2">
              <!-- <app-button
                [success]="true"
                (click)="onClickSetBet(betType.CALL)"
                [isSelected]="selectedBet === betType.CALL"
                [rounded]="true"
                [disabled]="disableBetting"
                [md]="true"
              >
                Call
              </app-button> -->
              <!-- {{ this.maxBet < this.minBet }} <br>
              {{ this.chips < this.minBet }}<br>
              {{ this.betAmount <= 0 }}<br>
              {{ this.isBetLock }}<br>
              {{ this.betAmount > this.maxBet }}<br>
              {{ this.betAmount < this.minBet }}<br>
              {{this.betAmount}} -->
              <button
                class="md:btn-betting-md btn-betting"
                (click)="onClickSetBet(betType.CALL)"
                [class.selected-call]="selectedBet === betType.CALL"
                [disabled]="disableBetting"
              >
                Call
              </button>
              <button
                class="md:btn-betting-md btn-betting"
                (click)="onClickFoldBet()"
                [class.selected-fold]="selectedBet === betType.FOLD"
                [disabled]="isBetLock"
              >
                Fold
              </button>
            </div>
          </div>
        </ng-template>

        <div class="deal-amount-container">
          <label class="font-bold">Deal Amount:</label>
          <input
            [disabled]="isBetLock"
            type="number"
            [(ngModel)]="betAmount"
            class="default-input"
          />
        </div>
      </div>
    </ng-template>

    <ng-template #waitingSection>
      <div class="mt-10 items-center text-center">
        <div
          *ngIf="mode !== modeType.BuyInOpen && mode !== modeType.Setup; else waitPlayersBetSection"
        >
          <p>Current seat number playing is seat #{{ currentSeatNoFromDealer }}</p>
          <p>Please wait for your turn</p>
        </div>
        <ng-template #waitPlayersBetSection> Waiting for all players to buy in</ng-template>
      </div>
    </ng-template>
  </ng-template>

  <button
    class="btn-buyin !h-8 md:!h-10"
    (click)="onClickBuyIn()"
    [disabled]="disableBuyIn || showSpinner"
  >
    {{ buyInLabel }}
  </button>

  <app-modal [showModal]="showChipsRequestModal" (closeEmitter)="showChipsRequestModal = false">
    <app-chips-request-v1
      *ngIf="showChipsRequestModal"
      (onSuccess)="showChipsRequestModal = false"
    ></app-chips-request-v1>
  </app-modal>
  <app-sm-spinner class="mt-4 w-full text-center" *ngIf="showSpinner"></app-sm-spinner>
</div>
